import * as actionType from "../constants";
import * as commonData from "../Common";
export const relateViceVersa =
  (input, any = null) =>
  async (dispatch) => {
    try {
      const respData = await fetch(
        `${commonData.commonData().apiUrl}project/update`,
        {
          method: "POST",
          body: JSON.stringify(input),
        }
      );
      const rdata = await respData.json();
      if (rdata.code === 200) {
        if (any == "status") {
          return rdata;
        }
        dispatch({
          type: actionType.RELATE_VICE_VERSA,
          payload: input?.project,
        });
        return rdata;
      }
    } catch (err) {
      console.log(err.message);
    }
  };
